import {
  BlogByIdDataTypes,
  BlogCategoryByIdParams, CreateUpdateBlogCategoryByIdParamsTypes,
  CreateUpdateBlogParamsTypes,
  DeleteBlogParamsTypes,
  GetAllBlogCategoryTypes, GetAllBlogServiceTypes, GetBlogByIdParamsTypes, GetBlogCategoryByIdTypes,
  PreviewBlogReponse
} from './types';

import axiosInstance from 'common/services/common/instance';

/* BLOG CATEGORY */

export const getAllBlogCategoryService = async (params?: BaseFilterParams):
  Promise<APIPaginationResponse<GetAllBlogCategoryTypes[]>> => {
  const res = await axiosInstance.get('blog-categories', { params });
  return res.data;
};

export const getBlogCategoryByIdService = async (
  params: BlogCategoryByIdParams
): Promise<GetBlogCategoryByIdTypes> => {
  const res = await axiosInstance.get(`blog-categories/${params.id}?locale=${params.locale}`);
  return res.data.data;
};

export const updateBlogCategoryByIdService = async (
  id: number,
  params: CreateUpdateBlogCategoryByIdParamsTypes,
) => {
  const res = await axiosInstance.put(`blog-categories/${id}`, params);
  return res.data.data;
};

export const createBlogCategoryByIdService = async (
  params: CreateUpdateBlogCategoryByIdParamsTypes
) => {
  const res = await axiosInstance.post('blog-categories', params);
  return res.data.data;
};

export const deleteBlogCategoryService = async (params: { ids: number[] }) => {
  const res = await axiosInstance.delete('blog-categories', { data: params });
  return res.data;
};
export const deleteBlogCategoryTranslationService = async (params: { ids: number[] }) => {
  const res = await axiosInstance.delete('blog-categories/translations', { data: params });
  return res.data;
};

export const updateBlogCategoryStatusService = async (
  id: number,
  status: number
): Promise<void> => {
  await axiosInstance.put(`blog-categories/${id}/update-status`, { status });
};

export const changeStatusBlogCategoryManyIdService = async (ids: number[], status: number)
  : Promise<void> => {
  await axiosInstance.put('blog-categories/update-status-with-many-id', { status, ids });
};

/* BLOG */
export const getBlogService = async (params?: BaseFilterParams):
  Promise<APIPaginationResponse<GetAllBlogServiceTypes[]>> => {
  const res = await axiosInstance.get('blogs', { params });
  return res.data;
};

export const getBlogByIdService = async (
  params: GetBlogByIdParamsTypes
): Promise<BlogByIdDataTypes> => {
  const res = await axiosInstance.get(`blogs/${params.id}?locale=${params.locale}`);
  return res.data.data;
};

export const deleteBlogService = async (params: DeleteBlogParamsTypes) => axiosInstance.delete('blogs', { data: params });
export const deleteBlogTranslationService = async (params: DeleteBlogParamsTypes) => axiosInstance.delete('blogs/translations', { data: params });

export const updateBlogByIdService = async (id: number, params: CreateUpdateBlogParamsTypes) => axiosInstance.put(`blogs/${id}`, params);

export const createBlogService = async (params: CreateUpdateBlogParamsTypes):
  Promise<{ id: number }> => {
  const response = await axiosInstance.post('blogs', params);
  return response.data.data;
};

export const previewBlogService = async (
  params: CreateUpdateBlogParamsTypes
): Promise<PreviewBlogReponse> => {
  const response = await axiosInstance.post('blogs/preview', params);
  return response.data.data;
};

export const updateBlogStatusService = async (id: number, status: number): Promise<void> => {
  await axiosInstance.put(`blogs/${id}/update-status`, { status });
};

export const changeStatusManyIdService = async (ids: number[], status: number): Promise<void> => {
  await axiosInstance.put('blogs/update-status-with-many-id', { status, ids });
};
